// Revisado: 2025-12-18 [I18n Scan]
/**
 * Calculates the skill cost based on base cost and level.
 * 
 * Discounts:
 * Lv 0: 0%
 * Lv 1: 10%
 * Lv 2: 20%
 * Lv 3: 30%
 * Lv 4: 35%
 * Lv 5 (Max): 40%
 * 
 * @param {number} baseCost - The base cost of the skill
 * @param {number} level - The current level of the skill (0-5)
 * @returns {number} The calculated cost
 */
export const calculateSkillCost = (baseCost, level, isFastLearner = false) => {
    if (!baseCost) return 0;

    let discount = 0;
    switch (level) {
        case 1: discount = 0.10; break;
        case 2: discount = 0.20; break;
        case 3: discount = 0.30; break;
        case 4: discount = 0.35; break;
        case 5: discount = 0.40; break;
        default: discount = 0;
    }

    if (isFastLearner) {
        discount += 0.10;
    }

    let finalCost = baseCost * (1 - discount);

    // Fix floating point precision errors (e.g. 10.5000001 -> 10.5)
    finalCost = parseFloat(finalCost.toFixed(4));

    // Custom Rounding: <= 0.5 rounds DOWN, > 0.5 rounds UP.
    // Equivalent to Math.ceil(x - 0.5) but more explicit for floating points
    const decimalPart = finalCost % 1;
    if (decimalPart <= 0.5) {
        return Math.floor(finalCost);
    } else {
        return Math.ceil(finalCost);
    }
};
// Revisado: 2025-12-16
